<template>
   <div class="container-wrapper">
      <div class="breadcrumb-wrapper">设备列表</div>

      <div class="margin-left-20">
         <el-button :type="currentIndex == 0 ? 'primary' : 'plain'" @click="clickIndex(0)">一体机</el-button>
         <el-button :type="currentIndex == 1 ? 'primary' : 'plain'" @click="clickIndex(1)">一体机(二代)</el-button>
         <el-button :type="currentIndex == 2 ? 'primary' : 'plain'" @click="clickIndex(2)">体检一体机</el-button>
         <el-button :type="currentIndex == 3 ? 'primary' : 'plain'" @click="clickIndex(3)">智慧体育盒子</el-button>
         <el-button :type="currentIndex == 4 ? 'primary' : 'plain'" @click="clickIndex(4)">智慧体育盒子(场馆监控)</el-button>
         <el-button :type="currentIndex == 5 ? 'primary' : 'plain'" @click="clickIndex(5)">坐位体前屈</el-button>
      </div>

      <EquipmentAIO v-if="currentIndex == 0" />
      <EquipmentAIOTwo v-if="currentIndex == 1" />
      <EquipmentPhysical v-if="currentIndex == 2" />
      <EquipmentBox v-if="currentIndex == 3" />
      <EquipmentBoxVenue v-if="currentIndex == 4" />
      <EquipmentSit v-if="currentIndex == 5" />
   </div>
</template>

<script>
import EquipmentAIO from './EquipmentAIO/EquipmentAIO.vue';
import EquipmentAIOTwo from './EquipmentAIOTwo/EquipmentAIOTwo.vue';
import EquipmentPhysical from './EquipmentPhysical/EquipmentPhysical.vue';
import EquipmentBox from './EquipmentBox/EquipmentBox.vue';
import EquipmentBoxVenue from './EquipmentBoxVenue/EquipmentBoxVenue.vue';
import EquipmentSit from './EquipmentSit/EquipmentSit.vue';

export default {
   components: {
      EquipmentAIO,
      EquipmentAIOTwo,
      EquipmentPhysical,
      EquipmentBox,
      EquipmentBoxVenue,
      EquipmentSit
   },

   data() {
      return {
         currentIndex: 0,
      }
   },

   methods: {
      // 点击切换按钮
      clickIndex(index) {
         if (this.currentIndex == index) {
            return;
         }
         this.currentIndex = index;
      },
   },
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// EquipmentList.vue?34cc37ec